import { Tag } from '@bbl-digital/snorre'
import {
  IMessageRecipient,
  RecipientTypeEnum,
} from 'Modules/Communication/shared/models/Inbox'
import { MessageTypeEnum } from 'Modules/Communication/shared/models/Recipients'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { ILoadingMessageRecipient } from 'shared/models/Message'
import { getEmailRecipientsLoading } from 'shared/store/sendMessage/email/selectors'
import { getSmsRecipientsLoading } from 'shared/store/sendMessage/sms/selectors'
import { Options } from '../styles'

interface IProps {
  recipients: IMessageRecipient[]
  messageType: MessageTypeEnum
  recipientType: RecipientTypeEnum
  onTagClick: (recipient: IMessageRecipient) => void
}

const OptionList: FC<IProps> = ({
  recipients,
  messageType,
  recipientType,
  onTagClick,
}) => {
  const isEmail = messageType === MessageTypeEnum.Email
  const loadingSelector = isEmail
    ? getEmailRecipientsLoading
    : getSmsRecipientsLoading

  const loading = useSelector(
    loadingSelector as (state: unknown) => ILoadingMessageRecipient[]
  )

  const loadingRemoving = loading.filter(
    (r) => r.type === 'remove' && r.recipientType === recipientType
  )
  const loadingAdding = loading.filter(
    (r) => r.type === 'add' && r.recipientType === recipientType
  )

  const loadingList = loadingAdding.map((item) => (
    <Tag strictClose key={item.id} loading />
  ))

  const list = recipients
    ?.filter((rec) => rec.recipientType === recipientType)
    .map((recipient) => {
      const name =
        messageType === MessageTypeEnum.SMS
          ? recipient.phonenumber
          : recipient.email || ''

      return (
        <Tag
          key={recipient.nameregisterId || name}
          title={name}
          strictClose
          onClick={() => onTagClick(recipient)}
          loading={loadingRemoving.some(
            (item) =>
              (item.id === recipient.nameregisterId ||
                item.id === recipient.email) &&
              item.type === 'remove'
          )}
        >
          {(recipient.name || name || '').substring(0, 35)}
          {(recipient.name || name || '').length > 35 && '...'}
        </Tag>
      )
    })

  if (!list.length && !loadingAdding.length) return null

  return (
    <Options>
      {list}
      {loadingList}
    </Options>
  )
}

export default OptionList
